<template>
  <div class="l-container AgreementsAdd">
    <p class="m-label">生徒選択</p>

    <div class="index-box">

      <table-c>
        <tr-c slot="tr-th">
          <td-c><input v-model="search.id" type="text" @keyup="searchTable()" placeholder="検索"></td-c>
          <td-c><input v-model="search.name" type="text" @keyup="searchTable()" v-focus></td-c>
          <td-c><input v-model="search.kana" type="text" @keyup="searchTable()"></td-c>
          <td-c class="select">
            <multiselect @select="select, searchTable()" v-model="watchSearch.pref" :options="pref" label="name" placeholder="" :show-labels="false"></multiselect>
          </td-c>
          <td-c><input v-model="search.address" type="text" @keyup="searchTable()"></td-c>
          <td-c><input v-model="search.tel1" type="text" @keyup="searchTable()"></td-c>
          <td-c><input v-model="search.tel2" type="text" @keyup="searchTable()"></td-c>
          <td-c><input v-model="search.fax" type="text" @keyup="searchTable()"></td-c>
          <td-c><input v-model="search.mail" type="text" @keyup="searchTable()"></td-c>
          <td-c><input v-model="search.created_at" type="text" @keyup="searchTable()"></td-c>
        </tr-c>

        <tr-c slot="tr-th">
          <td-c><input v-model="search.not_id" type="text" @keyup="searchTable()" placeholder="除外"></td-c>
          <td-c><input v-model="search.not_name" type="text" @keyup="searchTable()"></td-c>
          <td-c><input v-model="search.not_kana" type="text" @keyup="searchTable()"></td-c>
          <td-c class="select">
            <multiselect @select="select, searchTable()" v-model="watchSearch.not_pref" :options="pref" label="name" placeholder="" :show-labels="false"></multiselect>
          </td-c>
          <td-c><input v-model="search.not_address" type="text" @keyup="searchTable()"></td-c>
          <td-c><input v-model="search.not_tel1" type="text" @keyup="searchTable()"></td-c>
          <td-c><input v-model="search.not_tel2" type="text" @keyup="searchTable()"></td-c>
          <td-c><input v-model="search.not_fax" type="text" @keyup="searchTable()"></td-c>
          <td-c><input v-model="search.not_mail" type="text" @keyup="searchTable()"></td-c>
          <td-c><input v-model="search.not_created_at" type="text" @keyup="searchTable()"></td-c>
        </tr-c>

        <tr-c slot="tr-th">
          <th-c @click.native='sort("id")'>生徒ID</th-c>
          <th-c @click.native='sort("f_name + l_name")'>生徒名前</th-c>
          <th-c @click.native='sort("f_name_kana + l_name_kana")'>生徒読み</th-c>
          <th-c @click.native='sort("pref")'>都道府県</th-c>
          <th-c @click.native='sort("address1 + address2")'>住所</th-c>
          <th-c @click.native='sort("tel1")'>携帯TEL</th-c>
          <th-c @click.native='sort("tel2")'>固定TEL</th-c>
          <th-c @click.native='sort("fax")'>FAX</th-c>
          <th-c @click.native='sort("mail")'>MAIL</th-c>
          <th-c @click.native='sort("created_at")'>登録日</th-c>
        </tr-c>
        <tr-c slot="tr-td" @click.native="getData(list), input(list)" v-for="(list, index) in orderedStudents" :key="index.id">
          <template v-if="agreement.student_id === list.id">
            <td-c class="clicked">{{list.id}}</td-c>
            <td-c class="clicked">{{list.f_name}} {{list.l_name}}</td-c>
            <td-c class="clicked">{{list.f_name_kana}} {{list.l_name_kana}}</td-c>
            <td-c class="clicked">
              <template v-if="list.family.pref === 0">未選択</template>
              <template v-if="list.family.pref === 1">北海道</template>
              <template v-if="list.family.pref === 2">青森県</template>
              <template v-if="list.family.pref === 3">秋田県</template>
              <template v-if="list.family.pref === 4">岩手県</template>
              <template v-if="list.family.pref === 5">山形県</template>
              <template v-if="list.family.pref === 6">宮城県</template>
              <template v-if="list.family.pref === 7">福島県</template>
              <template v-if="list.family.pref === 8">栃木県</template>
              <template v-if="list.family.pref === 9">山梨県</template>
              <template v-if="list.family.pref === 10">群馬県</template>
              <template v-if="list.family.pref === 11">茨城県</template>
              <template v-if="list.family.pref === 12">千葉県</template>
              <template v-if="list.family.pref === 13">埼玉県</template>
              <template v-if="list.family.pref === 14">東京都</template>
              <template v-if="list.family.pref === 15">神奈川県</template>
              <template v-if="list.family.pref === 16">静岡県</template>
              <template v-if="list.family.pref === 17">長野県</template>
              <template v-if="list.family.pref === 18">愛知県</template>
              <template v-if="list.family.pref === 19">岐阜県</template>
              <template v-if="list.family.pref === 20">新潟県</template>
              <template v-if="list.family.pref === 21">富山県</template>
              <template v-if="list.family.pref === 22">石川県</template>
              <template v-if="list.family.pref === 23">福井県</template>
              <template v-if="list.family.pref === 24">滋賀県</template>
              <template v-if="list.family.pref === 25">京都府</template>
              <template v-if="list.family.pref === 26">三重県</template>
              <template v-if="list.family.pref === 27">和歌山県</template>
              <template v-if="list.family.pref === 28">奈良県</template>
              <template v-if="list.family.pref === 29">大阪府</template>
              <template v-if="list.family.pref === 30">兵庫県</template>
              <template v-if="list.family.pref === 31">鳥取県</template>
              <template v-if="list.family.pref === 32">島根県</template>
              <template v-if="list.family.pref === 33">岡山県</template>
              <template v-if="list.family.pref === 34">広島県</template>
              <template v-if="list.family.pref === 35">山口県</template>
              <template v-if="list.family.pref === 36">高知県</template>
              <template v-if="list.family.pref === 37">徳島県</template>
              <template v-if="list.family.pref === 38">香川県</template>
              <template v-if="list.family.pref === 39">愛媛県</template>
              <template v-if="list.family.pref === 40">福岡県</template>
              <template v-if="list.family.pref === 41">佐賀県</template>
              <template v-if="list.family.pref === 42">長崎県</template>
              <template v-if="list.family.pref === 43">熊本県</template>
              <template v-if="list.family.pref === 44">宮崎県</template>
              <template v-if="list.family.pref === 45">大分県</template>
              <template v-if="list.family.pref === 46">鹿児島県</template>
              <template v-if="list.family.pref === 47">沖縄県</template>
            </td-c>
            <td-c class="clicked">{{list.family.address1}}{{list.family.address2}}</td-c>
            <td-c class="clicked">{{list.family.tel1}}</td-c>
            <td-c class="clicked">{{list.family.tel2}}</td-c>
            <td-c class="clicked">{{list.family.fax}}</td-c>
            <td-c class="clicked">{{list.family.mail}}</td-c>
            <td-c class="clicked">{{list.created_at.substring(0, 10)}}</td-c>
          </template>
          <template v-if="agreement.student_id !==  list.id">
            <td-c>{{list.id}}</td-c>
            <td-c>{{list.f_name}} {{list.l_name}}</td-c>
            <td-c>{{list.f_name_kana}} {{list.l_name_kana}}</td-c>
            <td-c>
              <template v-if="list.family.pref === 0">未選択</template>
              <template v-if="list.family.pref === 1">北海道</template>
              <template v-if="list.family.pref === 2">青森県</template>
              <template v-if="list.family.pref === 3">秋田県</template>
              <template v-if="list.family.pref === 4">岩手県</template>
              <template v-if="list.family.pref === 5">山形県</template>
              <template v-if="list.family.pref === 6">宮城県</template>
              <template v-if="list.family.pref === 7">福島県</template>
              <template v-if="list.family.pref === 8">栃木県</template>
              <template v-if="list.family.pref === 9">山梨県</template>
              <template v-if="list.family.pref === 10">群馬県</template>
              <template v-if="list.family.pref === 11">茨城県</template>
              <template v-if="list.family.pref === 12">千葉県</template>
              <template v-if="list.family.pref === 13">埼玉県</template>
              <template v-if="list.family.pref === 14">東京都</template>
              <template v-if="list.family.pref === 15">神奈川県</template>
              <template v-if="list.family.pref === 16">静岡県</template>
              <template v-if="list.family.pref === 17">長野県</template>
              <template v-if="list.family.pref === 18">愛知県</template>
              <template v-if="list.family.pref === 19">岐阜県</template>
              <template v-if="list.family.pref === 20">新潟県</template>
              <template v-if="list.family.pref === 21">富山県</template>
              <template v-if="list.family.pref === 22">石川県</template>
              <template v-if="list.family.pref === 23">福井県</template>
              <template v-if="list.family.pref === 24">滋賀県</template>
              <template v-if="list.family.pref === 25">京都府</template>
              <template v-if="list.family.pref === 26">三重県</template>
              <template v-if="list.family.pref === 27">和歌山県</template>
              <template v-if="list.family.pref === 28">奈良県</template>
              <template v-if="list.family.pref === 29">大阪府</template>
              <template v-if="list.family.pref === 30">兵庫県</template>
              <template v-if="list.family.pref === 31">鳥取県</template>
              <template v-if="list.family.pref === 32">島根県</template>
              <template v-if="list.family.pref === 33">岡山県</template>
              <template v-if="list.family.pref === 34">広島県</template>
              <template v-if="list.family.pref === 35">山口県</template>
              <template v-if="list.family.pref === 36">高知県</template>
              <template v-if="list.family.pref === 37">徳島県</template>
              <template v-if="list.family.pref === 38">香川県</template>
              <template v-if="list.family.pref === 39">愛媛県</template>
              <template v-if="list.family.pref === 40">福岡県</template>
              <template v-if="list.family.pref === 41">佐賀県</template>
              <template v-if="list.family.pref === 42">長崎県</template>
              <template v-if="list.family.pref === 43">熊本県</template>
              <template v-if="list.family.pref === 44">宮崎県</template>
              <template v-if="list.family.pref === 45">大分県</template>
              <template v-if="list.family.pref === 46">鹿児島県</template>
              <template v-if="list.family.pref === 47">沖縄県</template>
            </td-c>
            <td-c>{{list.family.address1}}{{list.family.address2}}</td-c>
            <td-c>{{list.family.tel1}}</td-c>
            <td-c>{{list.family.tel2}}</td-c>
            <td-c>{{list.family.fax}}</td-c>
            <td-c>{{list.family.mail}}</td-c>
            <td-c>{{list.created_at.substring(0, 10)}}</td-c>
          </template>
        </tr-c>
      </table-c>
    </div>

    <p class="m-label">
      新規追加
      <span class="errors">
        <span v-if="!valid"> {{errors}} が入力されていません</span>
        <span v-if="valid"></span>
      </span>
    </p>

    <btn @click.native="reset">Reset</btn>

    <form class="h-adr" @submit.prevent="postAgreement">
      <div class="form-wrapper">
        <agreement-form :agreement="agreement" :watch="watchAgreement"></agreement-form>
      </div>

      <button type="submit" class="u-btn"><i class="fa fa-user-plus"></i>契約情報を新規追加</button>
    </form>

  </div>
</template>

<script>
import { getAPIURL } from '@/store/getters.js'
import config from '@/settings/config.js'
const url = getAPIURL() + '/api/v1/students/search?limit=' + config.LIMIT

var obj = {
  timer: null,
  TIMER: null,
  COUNT: 1,
  max: config.LIMIT,
  url: url,
  pageName: 'student',
  pageNames: 'students'
}

let _ = window._
export default {
  computed: {
    students () {
      return this.$store.getters.students
    },

    // filter By
    // filteredStudents () {
    //   var self = this // function の中でthisが使えないのでselfに置き換え
    //   return self.students.filter((el) => {
    //     let re = new RegExp(self.searchQuery) // searchQueryを正規表現に変換
    //     return re.test(el[self.searchType.value]) // searchTypeの中にre(searchQuery)があるかないかを正規表現で判別
    //   })
    // },

    // limit By
    // limitedStudents () {
    //   return this.students.slice(0, 5)
    // },

    // order By
    orderedStudents () {
      if (this.sortState === '' || this.sortState === 'asc') {
        return _.orderBy(this.students, this.asc)
      } else if (this.sortState === 'desc') {
        return _.orderBy(this.students, this.desc).reverse()
      }
    },

    // validation
    student_idErrors () {
      return this.agreement.student_id ? [] : ['生徒選択']
    },

    telErrors () {
      return this.agreement.tel ? [] : ['携帯TEL']
    },

    contract_typeErrors () {
      return this.agreement.contract_type ? [] : ['契約種類']
    },

    contract_dateErrors () {
      return this.agreement.contract_date ? [] : ['契約日付']
    },

    payment_typeErrors () {
      return this.agreement.payment_type ? [] : ['支払方法種別']
    },

    text_typeErrors () {
      return this.agreement.text_type ? [] : ['テキスト種類']
    },

    payments_numberErrors () {
      return this.agreement.payments_number ? [] : ['支払回数']
    },

    admission_feeErrors () {
      return this.agreement.admission_fee ? [] : ['入会金']
    },

    depositErrors () {
      return this.agreement.deposit ? [] : ['保証金']
    },

    errors () {
      let errors = [].concat(
        this.student_idErrors,
        this.telErrors,
        this.contract_typeErrors,
        this.contract_dateErrors,
        this.payment_typeErrors,
        this.text_typeErrors,
        this.payments_numberErrors,
        this.admission_feeErrors,
        this.depositErrors
      )
      let errorsJoin = errors.join('・')
      return errorsJoin
    },
    valid: function () {
      return !this.errors
    }
  },
  directives: {
    focus: {
      inserted (el, binding) {
        el.focus()
        // console.log(el)
        // console.log(binding)
      }
    }
  },
  data () {
    return {
      // searchQuery: '',
      // searchType: '',
      asc: '',
      desc: '',
      sortState: 'desc',

      agreement: {
        // user_id: '',
        student_id: '',
        payroll_check: '',
        contract_type: '',
        contract_date: '',
        change_date: '',
        cancel_type: '',
        cancel_date: '',
        f_name: '',
        l_name: '',
        f_name_kana: '',
        l_name_kana: '',
        tel: '',
        tel2: '',
        address: '',
        address2: '',
        // birthday: '',
        // hourly_pay: '',
        // split_commission: '',
        // sales_commission: '',
        // sales_commission_head: '',
        // sales_commission_branch: '',
        // pure_amount_head: '',
        // pure_amount_branch: '',
        // old_amount: '',
        // agency_commission: '',
        // agency_commission_head: '',
        // agency_commission_branch: '',
        // purchase_amount: '',
        // purchase_amount_head: '',
        // purchase_amount_branch: '',
        // only_total_amount: '',
        // only_total_amount_head: '',
        // only_total_amount_branch: '',
        // down_payment: '',
        // deposit_amount: '',
        deposit_amount_date: '',
        person: '',
        product_name: '',
        payment_type: '',
        payments_number: '',
        text_type: '',
        amount: '',
        discount: '',
        pure_amount: '',
        division_commission: '',
        total_amount: '',
        // text_grade_number: '',
        text_payment_period_start: '',
        text_payment_period_end: '',
        service_period_start: '',
        service_period_end: '',
        // administrative_expense: '',
        // first_month_deposit: '',
        first_month_deposit_method: '',
        first_month_deposit_check: '',
        admission_fee: '',
        admission_fee_method: 0,
        admission_fee_check: '',
        deposit: '',
        deposit_method: 0,
        deposit_check: '',
        bank_number: '',
        branch_number: '',
        deposit_item: 0,
        account_number: '',
        account_holder: '',
        expected_refund_date: '',
        deposit_refund_date: '',
        approval_date: '',
        approval_number: '',
        delivery_date: '',
        contract_collection_date: '',
        factor_collection_date: '',
        factor_check: 0,
        ledger_check: 0,
        cancel_check: 0,
        change_check: 0,
        grade: '',
        // point_s: '',
        // point_c: '',
        // point_k: '',
        // point_s_bulk: '',
        // point_c_bulk: '',
        // point_k_bulk: '',
        point_total: '',
        note: ''
      },

      watchAgreement: {
        contract_type: '',
        cancel_type: '',
        payment_type: '',
        payments_number: '',
        text_type: '',
        first_month_deposit_method: '',
        admission_fee_method: '',
        deposit_method: '',
        deposit_item: '',
        factor_check: '',
        ledger_check: '',
        cancel_check: '',
        change_check: ''
      },

      search: {
        id: '',
        name: '',
        kana: '',
        pref: '',
        address: '',
        tel1: '',
        tel2: '',
        fax: '',
        mail: '',
        created_at: '',

        not_id: '',
        not_name: '',
        not_kana: '',
        not_pref: '',
        not_address: '',
        not_tel1: '',
        not_tel2: '',
        not_fax: '',
        not_mail: '',
        not_created_at: ''
      },

      watchSearch: {
        pref: '',
        not_pref: ''
      },

      pref: [
        { name: '未選択', value: 0 },
        { name: '北海道', value: 1 },
        { name: '青森県', value: 2 },
        { name: '秋田県', value: 3 },
        { name: '岩手県', value: 4 },
        { name: '山形県', value: 5 },
        { name: '宮城県', value: 6 },
        { name: '福島県', value: 7 },
        { name: '栃木県', value: 8 },
        { name: '山梨県', value: 9 },
        { name: '群馬県', value: 10 },
        { name: '茨城県', value: 11 },
        { name: '千葉県', value: 12 },
        { name: '埼玉県', value: 13 },
        { name: '東京都', value: 14 },
        { name: '神奈川県', value: 15 },
        { name: '静岡県', value: 16 },
        { name: '長野県', value: 17 },
        { name: '愛知県', value: 18 },
        { name: '岐阜県', value: 19 },
        { name: '新潟県', value: 20 },
        { name: '富山県', value: 21 },
        { name: '石川県', value: 22 },
        { name: '福井県', value: 23 },
        { name: '滋賀県', value: 24 },
        { name: '京都府', value: 25 },
        { name: '三重県', value: 26 },
        { name: '和歌山県', value: 27 },
        { name: '奈良県', value: 28 },
        { name: '大阪府', value: 29 },
        { name: '兵庫県', value: 30 },
        { name: '鳥取県', value: 31 },
        { name: '島根県', value: 32 },
        { name: '岡山県', value: 33 },
        { name: '広島県', value: 34 },
        { name: '山口県', value: 35 },
        { name: '高知県', value: 36 },
        { name: '徳島県', value: 37 },
        { name: '香川県', value: 38 },
        { name: '愛媛県', value: 39 },
        { name: '福岡県', value: 40 },
        { name: '佐賀県', value: 41 },
        { name: '長崎県', value: 42 },
        { name: '熊本県', value: 43 },
        { name: '宮崎県', value: 44 },
        { name: '大分県', value: 45 },
        { name: '鹿児島県', value: 46 },
        { name: '沖縄県', value: 47 }
      ]
    }
  },
  watch: {
    'watchAgreement.contract_type': function (now, old) {
      // console.log(now)
      if (now) {
        this.agreement.contract_type = now.value
      } else {
        this.agreement.contract_type = ''
      }
    },

    'watchAgreement.cancel_type': function (now, old) {
      // console.log(now)
      if (now) {
        this.agreement.cancel_type = now.value
      } else {
        this.agreement.cancel_type = ''
      }
    },

    'watchAgreement.payment_type': function (now, old) {
      // console.log(now)
      if (now) {
        this.agreement.payment_type = now.value
      } else {
        this.agreement.payment_type = ''
      }
    },

    'watchAgreement.text_type': function (now, old) {
      // console.log(now)
      if (now) {
        this.agreement.text_type = now.value
      } else {
        this.agreement.text_type = ''
      }
    },

    'watchAgreement.payments_number': function (now, old) {
      // console.log(now)
      if (now) {
        this.agreement.payments_number = now.value
      } else {
        this.agreement.payments_number = ''
      }
    },

    'watchAgreement.first_month_deposit_method': function (now, old) {
      // console.log(now)
      if (now) {
        this.agreement.first_month_deposit_method = now.value
      } else {
        this.agreement.first_month_deposit_method = ''
      }
    },

    'watchAgreement.admission_fee_method': function (now, old) {
      // console.log(now)
      if (now) {
        this.agreement.admission_fee_method = now.value
      } else {
        this.agreement.admission_fee_method = ''
      }
    },

    'watchAgreement.deposit_method': function (now, old) {
      // console.log(now)
      if (now) {
        this.agreement.deposit_method = now.value
      } else {
        this.agreement.deposit_method = ''
      }
    },

    'watchAgreement.deposit_item': function (now, old) {
      // console.log(now)
      if (now) {
        this.agreement.deposit_item = now.value
      } else {
        this.agreement.deposit_item = ''
      }
    },

    'watchAgreement.factor_check': function (now, old) {
      // console.log(now)
      if (now) {
        this.agreement.factor_check = now.value
      } else {
        this.agreement.factor_check = ''
      }
    },

    'watchAgreement.ledger_check': function (now, old) {
      // console.log(now)
      if (now) {
        this.agreement.ledger_check = now.value
      } else {
        this.agreement.ledger_check = ''
      }
    },

    'watchAgreement.cancel_check': function (now, old) {
      // console.log(now)
      if (now) {
        this.agreement.cancel_check = now.value
      } else {
        this.agreement.cancel_check = ''
      }
    },

    'watchAgreement.change_check': function (now, old) {
      // console.log(now)
      if (now) {
        this.agreement.change_check = now.value
      } else {
        this.agreement.change_check = ''
      }
    }
  },

  methods: {
    select (selectedOption, id) {
      // console.log(selectedOption)
      // console.log(this.searchType)
    },

    getStudents () {
      this.$store.dispatch('getStudentsLimit0')
    },

    getAdvisors () {
      this.$store.dispatch('getAdvisors')
    },

    // order By
    sort (header) {
      if (this.sortState === '' || this.sortState === 'desc') {
        this.sortState = 'asc'
        this.asc = header
      } else if (this.sortState === 'asc') {
        this.sortState = 'desc'
        this.desc = header
      }
    },

    searchTable (e) {
      this.$store.dispatch('SEARCH', {
        this: this,
        e: e,
        obj: obj
      })
    },

    getData (student) {
      this.agreement.student_id = student.id
      // console.log(student)
      this.agreement.f_name = student.family.f_name
      this.agreement.l_name = student.family.l_name
      this.agreement.f_name_kana = student.family.f_name_kana
      this.agreement.l_name_kana = student.family.l_name_kana
      this.agreement.tel = student.family.tel1
      this.agreement.tel2 = student.family.tel2
      this.agreement.address = student.family.address1
      this.agreement.address2 = student.family.address2
      this.agreement.service_period_start = student.service_period_start
      this.agreement.service_period_end = student.service_period_end
    },

    input (student) {

    },

    postAgreement () {
      if (this.agreement.student_id) {
        // null falseかけていない為、契約リストずれないように、一回通過すれば今後おそらくこのアラートでない
        if (this.agreement.admission_fee_method === '') {
          alert('入会金支払方法を選択して下さい。')
        } else if (this.agreement.deposit_method === '') {
          alert('保証金支払方法を選択して下さい。')
        } else if (this.agreement.deposit_item === '') {
          alert('預金種目を選択して下さい。')
        } else if (this.agreement.factor_check === '') {
          alert('ファクターチェックを選択して下さい。')
        } else if (this.agreement.ledger_check === '') {
          alert('経理台帳入力を選択して下さい。')
        } else {
          this.$store.dispatch('postAgreement', {
            this: this,
            agreement: this.agreement,
            watch: this.watchAgreement,
            reset: this.reset
          })
          this.save()
        }
      } else {
        alert('紐づける生徒を選択して下さい。')
      }
    },

    save () {
      // alert('save')
      let arr = []
      let obj = {
        payroll_check: this.agreement.payroll_check,
        contract_type: this.watchAgreement.contract_type,
        contract_date: this.agreement.contract_date,
        change_date: this.agreement.change_date,
        cancel_type: this.watchAgreement.cancel_type,
        cancel_date: this.agreement.cancel_date,
        f_name: this.agreement.f_name,
        l_name: this.agreement.l_name,
        f_name_kana: this.agreement.f_name_kana,
        l_name_kana: this.agreement.l_name_kana,
        tel: this.agreement.tel,
        tel2: this.agreement.tel2,
        address: this.agreement.address,
        address2: this.agreement.address2,
        birthday: this.agreement.birthday,
        hourly_pay: this.agreement.hourly_pay,
        split_commission: this.agreement.split_commission,
        sales_commission: this.agreement.sales_commission,
        sales_commission_head: this.agreement.sales_commission_head,
        sales_commission_branch: this.agreement.sales_commission_branch,
        pure_amount_head: this.agreement.pure_amount_head,
        pure_amount_branch: this.agreement.pure_amount_branch,
        old_amount: this.agreement.old_amount,
        agency_commission: this.agreement.agency_commission,
        agency_commission_head: this.agreement.agency_commission_head,
        agency_commission_branch: this.agreement.agency_commission_branch,
        purchase_amount: this.agreement.purchase_amount,
        purchase_amount_head: this.agreement.purchase_amount_head,
        purchase_amount_branch: this.agreement.purchase_amount_branch,
        only_total_amount: this.agreement.only_total_amount,
        only_total_amount_head: this.agreement.only_total_amount_head,
        only_total_amount_branch: this.agreement.only_total_amount_branch,
        down_payment: this.agreement.down_payment,
        deposit_amount: this.agreement.deposit_amount,
        deposit_amount_date: this.agreement.deposit_amount_date,
        person: this.agreement.person,
        product_name: this.agreement.product_name,
        payment_type: this.watchAgreement.payment_type,
        payments_number: this.watchAgreement.payments_number,
        text_type: this.watchAgreement.text_type,
        amount: this.agreement.amount,
        discount: this.agreement.discount,
        pure_amount: this.agreement.pure_amount,
        division_commission: this.agreement.division_commission,
        total_amount: this.agreement.total_amount,
        text_grade_number: this.agreement.text_grade_number,
        text_payment_period_start: this.agreement.text_payment_period_start,
        text_payment_period_end: this.agreement.text_payment_period_end,
        service_period_start: this.agreement.service_period_start,
        service_period_end: this.agreement.service_period_end,
        administrative_expense: this.agreement.administrative_expense,
        first_month_deposit: this.agreement.first_month_deposit,
        first_month_deposit_method: this.watchAgreement.first_month_deposit_method,
        first_month_deposit_check: this.agreement.first_month_deposit_check,
        admission_fee: this.agreement.admission_fee,
        admission_fee_method: this.watchAgreement.admission_fee_method,
        admission_fee_check: this.agreement.admission_fee_check,
        deposit: this.agreement.deposit,
        deposit_method: this.watchAgreement.deposit_method,
        deposit_check: this.agreement.deposit_check,
        bank_number: this.agreement.bank_number,
        branch_number: this.agreement.branch_number,
        deposit_item: this.watchAgreement.deposit_item,
        account_number: this.agreement.account_number,
        account_holder: this.agreement.account_holder,
        expected_refund_date: this.agreement.expected_refund_date,
        deposit_refund_date: this.agreement.deposit_refund_date,
        approval_date: this.agreement.approval_date,
        approval_number: this.agreement.approval_number,
        delivery_date: this.agreement.delivery_date,
        contract_collection_date: this.agreement.contract_collection_date,
        factor_collection_date: this.agreement.factor_collection_date,
        factor_check: this.watchAgreement.factor_check,
        ledger_check: this.watchAgreement.ledger_check,
        cancel_check: this.watchAgreement.cancel_check,
        change_check: this.watchAgreement.change_check,
        grade: this.agreement.grade,
        point_s: this.agreement.point_s,
        point_c: this.agreement.point_c,
        point_k: this.agreement.point_k,
        point_s_bulk: this.agreement.point_s_bulk,
        point_c_bulk: this.agreement.point_c_bulk,
        point_k_bulk: this.agreement.point_k_bulk,
        point_total: this.agreement.point_total,
        note: this.agreement.note
      }
      arr.push(obj)
      let setjson = JSON.stringify(obj)
      localStorage.setItem('AgreementsAdd', setjson)
    },

    get () {
      // alert('get')
      let getjson = localStorage.getItem('AgreementsAdd')
      let obj = JSON.parse(getjson)
      this.agreement.payroll_check = obj['payroll_check']
      this.watchAgreement.contract_type = obj['contract_type']
      this.agreement.contract_date = obj['contract_date']
      this.agreement.change_date = obj['change_date']
      this.watchAgreement.cancel_type = obj['cancel_type']
      this.agreement.cancel_date = obj['cancel_date']
      this.agreement.f_name = obj['f_name']
      this.agreement.l_name = obj['l_name']
      this.agreement.f_name_kana = obj['f_name_kana']
      this.agreement.l_name_kana = obj['l_name_kana']
      this.agreement.tel = obj['tel']
      this.agreement.tel2 = obj['tel2']
      this.agreement.address = obj['address']
      this.agreement.address2 = obj['address2']
      this.agreement.birthday = obj['birthday']
      this.agreement.hourly_pay = obj['hourly_pay']
      this.agreement.split_commission = obj['split_commission']
      this.agreement.sales_commission = obj['sales_commission']
      this.agreement.sales_commission_head = obj['sales_commission_head']
      this.agreement.sales_commission_branch = obj['sales_commission_branch']
      this.agreement.pure_amount_head = obj['pure_amount_head']
      this.agreement.pure_amount_branch = obj['pure_amount_branch']
      this.agreement.old_amount = obj['old_amount']
      this.agreement.agency_commission = obj['agency_commission']
      this.agreement.agency_commission_head = obj['agency_commission_head']
      this.agreement.agency_commission_branch = obj['agency_commission_branch']
      this.agreement.purchase_amount = obj['purchase_amount']
      this.agreement.purchase_amount_head = obj['purchase_amount_head']
      this.agreement.purchase_amount_branch = obj['purchase_amount_branch']
      this.agreement.only_total_amount = obj['only_total_amount']
      this.agreement.only_total_amount_head = obj['only_total_amount_head']
      this.agreement.only_total_amount_branch = obj['only_total_amount_branch']
      this.agreement.down_payment = obj['down_payment']
      this.agreement.deposit_amount = obj['deposit_amount']
      this.agreement.deposit_amount_date = obj['deposit_amount_date']
      this.agreement.person = obj['person']
      this.agreement.product_name = obj['product_name']
      this.watchAgreement.payment_type = obj['payment_type']
      this.watchAgreement.payments_number = obj['payments_number']
      this.watchAgreement.text_type = obj['text_type']
      this.agreement.amount = obj['amount']
      this.agreement.discount = obj['discount']
      this.agreement.pure_amount = obj['pure_amount']
      this.agreement.division_commission = obj['division_commission']
      this.agreement.total_amount = obj['total_amount']
      this.agreement.text_grade_number = obj['text_grade_number']
      this.agreement.text_payment_period_start = obj['text_payment_period_start']
      this.agreement.text_payment_period_end = obj['text_payment_period_end']
      this.agreement.service_period_start = obj['service_period_start']
      this.agreement.service_period_end = obj['service_period_end']
      this.agreement.administrative_expense = obj['administrative_expense']
      this.agreement.first_month_deposit = obj['first_month_deposit']
      this.watchAgreement.first_month_deposit_method = obj['first_month_deposit_method']
      this.agreement.first_month_deposit_check = obj['first_month_deposit_check']
      this.agreement.admission_fee = obj['admission_fee']
      this.watchAgreement.admission_fee_method = obj['admission_fee_method']
      this.agreement.admission_fee_check = obj['admission_fee_check']
      this.agreement.deposit = obj['deposit']
      this.watchAgreement.deposit_method = obj['deposit_method']
      this.agreement.deposit_check = obj['deposit_check']
      this.agreement.bank_number = obj['bank_number']
      this.agreement.branch_number = obj['branch_number']
      this.watchAgreement.deposit_item = obj['deposit_item']
      this.agreement.account_number = obj['account_number']
      this.agreement.account_holder = obj['account_holder']
      this.agreement.expected_refund_date = obj['expected_refund_date']
      this.agreement.deposit_refund_date = obj['deposit_refund_date']
      this.agreement.approval_date = obj['approval_date']
      this.agreement.approval_number = obj['approval_number']
      this.agreement.delivery_date = obj['delivery_date']
      this.agreement.contract_collection_date = obj['contract_collection_date']
      this.agreement.factor_collection_date = obj['factor_collection_date']
      this.watchAgreement.factor_check = obj['factor_check']
      this.watchAgreement.ledger_check = obj['ledger_check']
      this.watchAgreement.cancel_check = obj['cancel_check']
      this.watchAgreement.change_check = obj['change_check']
      this.agreement.grade = obj['grade']
      this.agreement.point_s = obj['point_s']
      this.agreement.point_c = obj['point_c']
      this.agreement.point_k = obj['point_k']
      this.agreement.point_s_bulk = obj['point_s_bulk']
      this.agreement.point_c_bulk = obj['point_c_bulk']
      this.agreement.point_k_bulk = obj['point_k_bulk']
      this.agreement.point_total = obj['point_total']
      this.agreement.note = obj['note']
      // console.log(obj)
    },

    reset () {
      this.agreement.payroll_check = ''
      this.watchAgreement.contract_type = 0
      this.agreement.contract_date = ''
      this.agreement.change_date = ''
      this.watchAgreement.cancel_type = 0
      this.agreement.cancel_date = ''
      this.agreement.f_name = ''
      this.agreement.l_name = ''
      this.agreement.f_name_kana = ''
      this.agreement.l_name_kana = ''
      this.agreement.tel = ''
      this.agreement.tel2 = ''
      this.agreement.address = ''
      this.agreement.address2 = ''
      this.agreement.birthday = ''
      this.agreement.hourly_pay = ''
      this.agreement.split_commission = ''
      this.agreement.sales_commission = ''
      this.agreement.sales_commission_head = ''
      this.agreement.sales_commission_branch = ''
      this.agreement.pure_amount_head = ''
      this.agreement.pure_amount_branch = ''
      this.agreement.old_amount = ''
      this.agreement.agency_commission = ''
      this.agreement.agency_commission_head = ''
      this.agreement.agency_commission_branch = ''
      this.agreement.purchase_amount = ''
      this.agreement.purchase_amount_head = ''
      this.agreement.purchase_amount_branch = ''
      this.agreement.only_total_amount = ''
      this.agreement.only_total_amount_head = ''
      this.agreement.only_total_amount_branch = ''
      this.agreement.down_payment = ''
      this.agreement.deposit_amount = ''
      this.agreement.deposit_amount_date = ''
      this.agreement.person = ''
      this.agreement.product_name = ''
      this.watchAgreement.payment_type = 0
      this.watchAgreement.payments_number = 0
      this.watchAgreement.text_type = 0
      this.agreement.amount = ''
      this.agreement.discount = ''
      this.agreement.pure_amount = ''
      this.agreement.division_commission = ''
      this.agreement.total_amount = ''
      this.agreement.text_grade_number = ''
      this.agreement.text_payment_period_start = ''
      this.agreement.text_payment_period_end = ''
      this.agreement.service_period_start = ''
      this.agreement.service_period_end = ''
      this.agreement.administrative_expense = ''
      this.agreement.first_month_deposit = ''
      this.watchAgreement.first_month_deposit_method = 0
      this.agreement.first_month_deposit_check = ''
      this.agreement.admission_fee = ''
      this.watchAgreement.admission_fee_method = { name: '未選択', value: 0 }
      this.agreement.admission_fee_check = ''
      this.agreement.deposit = ''
      this.watchAgreement.deposit_method = { name: '未選択', value: 0 }
      this.agreement.deposit_check = ''
      this.agreement.bank_number = ''
      this.agreement.branch_number = ''
      this.watchAgreement.deposit_item = { name: '未選択', value: 0 }
      this.agreement.account_number = ''
      this.agreement.account_holder = ''
      this.agreement.expected_refund_date = ''
      this.agreement.deposit_refund_date = ''
      this.agreement.approval_date = ''
      this.agreement.approval_number = ''
      this.agreement.delivery_date = ''
      this.agreement.contract_collection_date = ''
      this.agreement.factor_collection_date = ''
      this.watchAgreement.factor_check = { name: '未選択', value: 0 }
      this.watchAgreement.ledger_check = { name: '未選択', value: 0 }
      this.watchAgreement.cancel_check = { name: '未選択', value: 0 }
      this.watchAgreement.change_check = { name: '未選択', value: 0 }
      this.agreement.grade = ''
      this.agreement.point_s = ''
      this.agreement.point_c = ''
      this.agreement.point_k = ''
      this.agreement.point_s_bulk = ''
      this.agreement.point_c_bulk = ''
      this.agreement.point_k_bulk = ''
      this.agreement.point_total = ''
      this.agreement.note = ''
    }
  },

  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.getStudents()
      vm.getAdvisors()
      vm.get()
    })
  },

  beforeRouteLeave (to, from, next) {
    this.save()
    next()
  }
}
</script>

<style lang="scss" scoped>
.form-wrapper {
  overflow: scroll;
  height: calc(100vh - 400px);
}
.errors {
  color: red;
}

.index-box {
  height: calc(100vh - 500px);
  overflow: scroll;
  margin-top: 10px;
}
.table {
  margin-top: 0 !important;
}
.th, .td {
  padding: 0.5rem 0.5rem !important;
  border-right: solid 1px #ccc;
}
.th {
  cursor: pointer;
}
.select {
  padding: 0 !important;
}
.fa-user-plus {
  margin-right: 5px;
}
.u-btn {
  margin-top: 1rem;
}
button {
  background-color: var(--color-point);
  color: #fff;
  margin-bottom: 13px;
  font-size:1rem;
  font-weight: bold;
  width: 100%;
  text-align: center;
  padding: 1em;
  border: 0;
  cursor: pointer;
  transition: opacity 0.5s ease-in-out;
  &:hover {
    opacity: .8;
  }
  &:focus {
    outline: 0;
  }
}
input {
  width: 100%;
  min-width: 100px;
  height: 100%;
  padding: 0;
  outline: 0;
  border: none;
}
.clicked {
  background: #41B883;
  font-weight: bold;
  color: #fff;
}
</style>
<style lang="scss">
.AgreementsAdd {
  .multiselect {
    min-height: 23px;
    min-width: 100px;
  }
  .multiselect__tags {
    border: solid 1px #ccc;
    min-height: 23px;
    padding: 0px 23px 0 2px;
    border-radius: 0;
    border: none;
    margin: 1px;
  }
  .multiselect__tags-wrap {
    background: red;
  }
  .multiselect__input {
    margin-bottom: 0;
    height: 23px;
  }
  .multiselect__select {
    height: 23px;
    width: 26px;
    top: 2px;
    padding: 0;
    &:before {
      top: 65%;
    }
  }
  .multiselect__single {
    margin-top: 3px;
    margin-bottom: 3px;
  }
}
</style>



// WEBPACK FOOTER //
// AgreementsAdd.vue?0f239e92